<template>
    <div>
        <ULink to="/" class="flex items-center gap-2">
            <img v-if="colorMode.value == 'dark'" src="/brand/logo-light.png" alt="Leadins" class="h-4 w-auto" />
            <img v-else src="/brand/logo-ink.png" alt="Leadins" class="h-4 w-auto" />
            <span class="font-prosto">Portal</span>
        </ULink>
    </div>
</template>

<script setup>
const colorMode = useColorMode()
</script>